export const contactsData = {
    email: 'info@algertzharri.com',
    phone: '+915588776600',
    address: '',
    sheetAPI: 'https://algertzharri.com/contact.php' // Replace with your actual domain
}